import { render, staticRenderFns } from "./administracion.vue?vue&type=template&id=313b2044&"
import script from "./administracion.vue?vue&type=script&lang=js&"
export * from "./administracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports